module.exports = __webpack_public_path__ + "static/media/logo-innovation.21b9f975.png";